<template>
	<div class="c-lightbox">
		<flickity ref="flickity" :options="flickityOptions">
			<div v-for="item in items" class="c-lightbox__content">
				<div class="c-lightbox__video" v-if="item.type === 'video' && hasCookieConsent" v-html="item.video.safeHtml"></div>

				<div class="c-embed__message" v-if="item.type === 'video' && !hasCookieConsent">
					<div class="c-embed__message-content">
						<p>This content is blocked</p>
						<p>Please enable cookies to view</p>

						<button
							class="c-btn c-btn--brand h-white-space-normal"
							@click="acceptRequiredCategories()"
						>
							{{ requiredCategoryString() }}
						</button>
					</div>
				</div>

				<v-image-bg
					v-if="item.type != 'video'"
					v-bind:image-id="item.imageId"
					v-bind:image-preview="'/images/loading--white.gif'"
					image-width="1080"
					image-height="1080"
					image-mode="fit"
					image-class="c-lightbox__image"
					preview-class="c-lightbox__preview"
					background-size="contain">
				</v-image-bg>

				<div class="c-lightbox__foot">
					<div class="c-lightbox__meta">
						<span class="c-lightbox__caption h-text--small" v-html="item.caption">Test</span>
						<span class="c-lightbox__credit  h-text--micro" v-html="item.credit">Test</span>
					</div>
				</div>
			</div>
		</flickity>
		<menu class="c-lightbox__nav">
			<button class="c-lightbox__prev" @click="previous()">
				<span class="h-accessibility">Prev</span>
				<span class="c-lightbox__icon icon i-chevron--left">
					<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>chevron-left</title><path d="M21 3.5l-13.89 14L21 31.5 17.5 35 0 17.5 17.5 0z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd"/></svg>
				</span>
			</button>
			<button class="c-lightbox__next" @click="next()"> <span class="h-accessibility">Next</span>
				<span class="c-lightbox__icon icon i-chevron--left">
					<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>chevron-right</title><path d="M0 31.5l13.89-14L0 3.5 3.5 0 21 17.5 3.5 35z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd"/></svg>
				</span>
			</button>
		</menu>
	</div>
</template>

<script>
	import Flickity from 'vue-flickity';
	import vImageBg from './image-loader-bg.vue';
	import CookieConsent from "../mixins/cookie-consent.vue";
	import Embed from "./embed.vue";
  export default {
		name: 'v-gallery-carousel',
	  mixins: [CookieConsent],
		components: {
        Embed,
        Flickity,
        vImageBg,
    },
    data () {
      return {
        flickityOptions: {
          initialIndex: this.index,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
					lazyLoad: 2
        }
      }
    },
		props: {
			items: {
				type: Object
			},
			requiredCookieCategories: {
				default: ['analytics', 'marketing'],
			},
			index: {
				type: Number
			}
		},
		mounted() {
			document.querySelector('.flickity-enabled').focus();
		},
    methods: {
      next() {
        this.$refs.flickity.next();
      },
      previous() {
        this.$refs.flickity.previous();
      }
    }
	}
</script>



// WEBPACK FOOTER //
// gallery-carousel.vue?b4eb9002